import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=3b436d2e"
import script from "./Statements.vue?vue&type=script&lang=ts"
export * from "./Statements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports